import React from "react";
import {withRouter} from 'react-router-dom'


class BaseBottomItem extends React.Component {

	toOther = () => {
		if (this.props.other) {
			const w = window.open('about:blank');
			w.location.href = this.props.url
		} else {
			this.props.history.push(this.props.url);
		}
	};

	render() {
		return (
			<div onClick={this.toOther}
				 style={{width: '100%'}}
			>{this.props.text}</div>
		)
	}
}

export default withRouter(BaseBottomItem)